module.exports = __webpack_public_path__ + "img/canbadge_heart_w57mm_line.915f9d18.png";